import { axios, path } from './config';
import qs from 'qs';
import { formatApiDateRange } from './utils';

export function campaign({ campaignId, dateRange }) {
  const params = {
    campaign_id: campaignId,
    date_range: formatApiDateRange({ dateRange }),
  };

  return axios.get(path.METRICS_CAMPAIGN, { params });
}

export function dashboardMetrics({ campaignId, dateRange }) {
  const params = {
    campaign_id: campaignId,
    date_range: formatApiDateRange({ dateRange }),
  };

  const updatedParams = qs.stringify(params);

  return axios.get(`${path.METRICS_TEAMS}${updatedParams}`);
}

export function userMetrics({ userId, dateRange }) {
  const params = {
    user_id: userId,
    date_range: formatApiDateRange({ dateRange }),
  };

  return axios.get(path.METRICS_USERS, { params });
}
export function userHourlyMetrics({ userId }) {
  const params = {
    user_id: userId,
  };

  return axios.get(path.METRICS_TEAMS_HOURLY_GRAPH, { params });
}
